<template>
<div v-if="load" class="loadComp">
  <spinner-1 class="spinner" :animation-duration="2000" :size="60" :color="'#ff8200'"/>
</div>
</template>

<script>

export default {
  name: 'loadComp',
  props: {
  },
  data () {
    return {
    }
  },
  componets: {
  },
  computed: {
    load () {
      return this.$store.getters.getLoad
    }
  }
}
</script>

<style scoped lang="scss">
.loadComp {
  z-index: 1000;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.4);
}
.spinner {
  position: absolute;
  top: calc(50% - 30px);
  left: calc(50% - 30px);
}
</style>
